import React from "react";

import InvoiceDeleteModal from "../InvoiceDeleteModal";
import InvoiceUpdateModal from "../InvoiceUpdateModal";
import InvoiceQRCodeModal from "../InvoiceQRCodeModal";

import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  setSelectedInvoice,
  setShowEditModal,
  setShowDeleteModal,
  setShowQRCodeModal,
} from "store/features/ibanInvoiceSlice";

const MODAL_ANIMATION_DELAY = 300;

interface InvoiceModalsProps {
  onAfterUpdateSubmit?: () => Promise<void>;
  onAfterDeleteSubmit?: () => Promise<void>;
}

const InvoiceModals: React.FC<InvoiceModalsProps> = ({
  onAfterUpdateSubmit,
  onAfterDeleteSubmit,
}) => {
  const dispatch = useAppDispatch();

  const selectedInvoice = useAppSelector(
    (state) => state.ibanInvoice.selectedInvoice,
  );
  const showEditModal = useAppSelector(
    (state) => state.ibanInvoice.showEditModal,
  );
  const showDeleteModal = useAppSelector(
    (state) => state.ibanInvoice.showDeleteModal,
  );
  const showQRCodeModal = useAppSelector(
    (state) => state.ibanInvoice.showQRCodeModal,
  );

  const clearSelectedInvoice = () => {
    setTimeout(() => {
      dispatch(setSelectedInvoice(null));
    }, MODAL_ANIMATION_DELAY);
  };

  const onCloseEditModal = () => {
    dispatch(setShowEditModal(false));
    clearSelectedInvoice();
  };

  const onCloseDeleteModal = () => {
    dispatch(setShowDeleteModal(false));
    clearSelectedInvoice();
  };

  const onCloseQRCodeModal = () => {
    dispatch(setShowQRCodeModal(false));
    clearSelectedInvoice();
  };

  return (
    <>
      <InvoiceDeleteModal
        isOpen={showDeleteModal}
        invoice={selectedInvoice}
        onAfterSubmit={onAfterDeleteSubmit}
        onClose={onCloseDeleteModal}
      />
      <InvoiceUpdateModal
        isOpen={showEditModal}
        invoice={selectedInvoice}
        onAfterSubmit={onAfterUpdateSubmit}
        onClose={onCloseEditModal}
      />
      <InvoiceQRCodeModal
        isOpen={showQRCodeModal}
        invoice={selectedInvoice}
        onClose={onCloseQRCodeModal}
      />
    </>
  );
};

export default InvoiceModals;
